import "@fontsource/rubik/400.css";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/700.css";
import { startGame } from "./game";
import { registerOffline } from "./pwa/register";
import { initUpdate } from "./ui/update";

// Before Rapier: if it fails to load, a fixed version must still reach the player
const update = initUpdate();
if (import.meta.env.PROD) registerOffline(update.show);

/* =====================================================================
   PHYSICS ENGINE: Rapier (Rust compiled to WebAssembly). The -compat build
   has the WebAssembly inlined, so this one import loads everything. It is a
   dynamic import so a failed load can still say so on the page.
   ===================================================================== */
const loadingEl = document.getElementById("loading") as HTMLElement;
let RAPIER: typeof import("@dimforge/rapier3d-compat").default;
try {
  RAPIER = (await import("@dimforge/rapier3d-compat")).default;
  await RAPIER.init();
} catch (err) {
  loadingEl.textContent =
    "The physics engine couldn’t be loaded" +
    (err instanceof Error && err.message ? ": " + err.message : ".");
  loadingEl.classList.add("error");
  update.gameFailed();
  throw err;
}
loadingEl.remove();

startGame(RAPIER);
